import React from 'react';
import DownArrowFilter from 'src/assets/images/DownArrowFilter.svg';
import { StyledArrowIcon } from './ArrowDownReverse.styled';

const ArrowDownReverse = (props) => {
    return (
        <>
            <StyledArrowIcon
                width={props.width}
                height={props.height}
                imgUrl={DownArrowFilter}
                isOpen={props.isOpen}
            />
        </>
    );
};

export default ArrowDownReverse;
